/**
 * @generated SignedSource<<bb77722bb422b0f2ca01ef8496fdb10f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardColumnOld_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardCard_query" | "BoardInlineCreate_query" | "BoardTransitionZones_query">;
  readonly " $fragmentType": "BoardColumnOld_query";
};
export type BoardColumnOld_query$key = {
  readonly " $data"?: BoardColumnOld_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BoardColumnOld_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "BoardColumnOld_query",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardCard_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardInlineCreate_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "BoardTransitionZones_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "d6c5997371e3af8debcf800ced0e93ce";

export default node;
